import { Form, Formik, FormikProps } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';

class SsoForm extends React.Component<any, any> {
    public render() {
        return (
            <div style={this.props.style}>
                <Formik
                    initialValues={{
                        environment: 'Production'
                    }}
                    onSubmit={this.props.onSubmit}
                    render={this.form}
                />
            </div>
        );
    }
    private form = (p: FormikProps<any>) => <Form>
        <TextField
            label='Environment'
            name='environment'
            margin="normal"
            variant="outlined"
            value={p.values.environment || ''}
            select={true}
            onChange={p.handleChange}
            onBlur={p.handleBlur}
        >
            {['Production', 'Beta'].map(e => (
                <MenuItem key={e} value={e}>
                    {e}
                </MenuItem>
            ))}
        </TextField>
        <Button style={{width: '100%'}} type="submit" color="primary">Integrate</Button>
    </Form>
}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(SsoForm));



// WEBPACK FOOTER //
// ./src/sub-projects/adobe/components/sso-form.tsx